<template>
  <div class="register_w">
    <div class="top_w bc_fff ">
      <div
        class="header_w site_content d_flex align_item_c justify_content_sb"
        style="padding: 24px 0"
      >
        <div class="d_flex align_item_c">
          <router-link to="/" class="d_inline_flex align_item_c cursor_pointer">
            <img :src="siteInfo.logo" alt="" />
          </router-link>
          <span class="span_2" />
          <span class="span_1 fz16 c_808080">用户注册</span>
        </div>

        <div class="fz16 div_1">
          <span class="c_808080">已有账号？</span>
          <router-link class="c_EF3946" to="/login">请登录 ></router-link>
        </div>
      </div>
    </div>

    <div class="">
      <div class="content_w">
        <div class="register_c_w x_y_center flex_direction_col">

          <!-- <div class="div_3 fz24 c_0983CC font_w_bold">欢迎注册</div> -->

          <el-form
            ref="registerForm"
            :model="registerForm"
            size="mini"
            :rules="rules"
            label-width="90px"
            @validate="onValidateForm"
          >
            <el-form-item prop="phone" label="手机号码">
              <div class="initial_input">
                <el-input
                  v-model="registerForm.phone"
                  placeholder="建议使用常用手机号"
                  @blur="onPhoneBlur"
                >
                  <i slot="prefix">
                    <img src="@/assets/images/register_1.png" alt="" />
                  </i>
                </el-input>
                <span class="span_3">
                  <img :src="phoneValidIcon" alt="" />
                </span>
              </div>
            </el-form-item>
            <el-form-item prop="smscode" label="验 证 码">
              <div class="warp_1">
                <el-input
                  v-model="registerForm.smscode"
                  placeholder="短信验证码"
                  :maxlength="input_l_150"
                >
                  <i slot="prefix">
                    <img src="@/assets/images/register_2.png" alt="" />
                  </i>
                </el-input>

                <div
                  :class="
                    countDown < 60 || !passPhone
                      ? 'disabled_btn send_vcode_btn'
                      : 'send_vcode_btn is_active'
                  "
                  @click="onSendVcodeClick"
                >
                  <span v-if="countDown === 60">获取短信验证码</span>
                  <span v-else>{{ countDown }}s后重新获取</span>
                </div>

                <span class="span_3">
                  <img
                    :src="
                      registerForm.smscode
                        ? require(`@/assets/images/` +
                            (registerForm.smscode
                              ? 'register_4.png'
                              : 'register_5.png'))
                        : ''
                    "
                    alt=""
                  />
                </span>
              </div>
            </el-form-item>
            <el-form-item prop="password" label="设置密码">
              <div class="initial_input">
                <el-input
                  v-model="registerForm.password"
                  placeholder="请设置6位数以上密码"
                  :type="passwordInputType"
                >
                  <i slot="prefix">
                    <img src="@/assets/images/register_3.png" alt="" />
                  </i>
                  <i
                    slot="suffix"
                    class="el-input__icon el-icon-view fz18 cursor_pointer"
                    @click="onVisiablePassword"
                  />
                </el-input>
                <span class="span_3">
                  <img
                    :src="
                      registerForm.password
                        ? require(`@/assets/images/` +
                            (isValidPassword
                              ? 'register_4.png'
                              : 'register_5.png'))
                        : ''
                    "
                    alt=""
                  />
                </span>
              </div>
            </el-form-item>
            <el-form-item>
              <div
                class="div_2 fz16 cursor_pointer text_center c_fff bc_0983CC"
                @click="onRegisterClick('registerForm')"
              >
                提交注册
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <MyFooter />


    <!-- 用户须知 -->
    <AgreementRead v-model="registerReadModal" :content="registerProtocol.content" :title="registerProtocol.title" @onCancal="onCancal" @onConfirm="onConfirm"/>
  </div>
</template>

<script>
import MyTop from "@/views/public_0983cc/MyTop.vue";
import MyFooter from "@/views/public_0983cc/MyFooter.vue";
import AgreementRead from '@/components/template/AgreementRead.vue'

import { user_gee_web_init } from "@/api/public";
import { user_sms_register } from "@/api/sms";
import { user_register, user_checkPhone } from "@/api/user";
import { isvalidPhone } from "@/utils";
import { mapGetters,mapActions } from 'vuex'
import {
  _input_l_150,
  _input_l_300,
  _input_l_500 } from '@/utils/setting'

import {validPasswordReg} from '@/utils/validFiled'

export default {
  components: { MyTop, MyFooter,AgreementRead },
  data() {
    const validPassword = (rule, value, callback) => {
      if(!value){
        callback(new Error("密码不能为空"));
      } else if (
        !validPasswordReg(value)
      ) {
        callback(new Error("密码必须以字母开头，且不小于6个字符，不能包含特殊字符。"));
      } else {
        callback();
      }
    };
    const validConfirmpsw = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请确认密码"));
      } else if (this.registerForm.password !== value) {
        callback(new Error("两次密码输入不一致"));
      } else {
        callback();
      }
    };
    const validAgree = (rule, value, callback) => {
      if (!this.registerForm.agree) {
        callback(new Error("请勾选用户服务协议"));
      } else {
        callback();
      }
    };
    const validPhone = (rule, value, callback) => {

      if (!value) {
        callback(new Error("请输入手机号码"));
      } else if (!isvalidPhone(value)) {
        callback(new Error("请输入正确的手机号码"));
      } else if (this.isAlreadyPhone) {
        callback(new Error("手机号已存在"));
      } else {
        callback();
      }

    };

    return {
      rules: {
        phone: [{ required: true, trigger: "blur", validator: validPhone }],

        smscode: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
        ],
        password: [
          { required: true, trigger: "blur", validator: validPassword },
        ],
        confirmpsw: [
          { required: true, trigger: "blur", validator: validConfirmpsw },
        ],
        agree: [{ required: true, trigger: "change", validator: validAgree }],
      },
      registerForm: {},
      countDown: 60, // 1分钟
      countDownTimer: null,

      readUserServeModal: false,
      privacyModal: false,

      passPhone: false, //手机号是否有效
      isAlreadyPhone:false, // 手机号已存在
      isValidPassword: false, //密码是否有效
      passwordInputType: "password",


      registerReadModal:true,
    };
  },
  computed: {
    ...mapGetters(['siteInfo','registerProtocol']),
    input_l_150() {
      return _input_l_150
    },
    input_l_300() {
      return _input_l_300
    },
    input_l_500() {
      return _input_l_500
    },
    // 有效手机号icon
    phoneValidIcon: function () {
      return this.registerForm.phone
        ? require(`@/assets/images/` +
            (this.passPhone ? "register_4.png" : "register_5.png"))
        : "";
    },
  },
  created() {
    this.initRegisterProtocol()
  },
  methods: {
    ...mapActions({
      'initRegisterProtocol':'cache/initRegisterProtocol'
    }),

    // 发送验证码 click
    async onSendVcodeClick() {
      if (!this.passPhone || this.countDown < 60) return;

      const { data } = await user_gee_web_init();

      await initGeetest(
        {
          // 以下配置参数来自服务端 SDK
          gt: data.gt,
          challenge: data.challenge,
          offline: !data.success,
          new_captcha: true,
          product: "bind",
        },
        (captchaObj) => {
          captchaObj
            .onReady(() => {
              captchaObj.verify(); // 显示验证码
            })
            .onSuccess(() => {
              this.sendValidCode(captchaObj.getValidate(), data);
            })
            .onError(() => {});
        }
      );
    },
    // 发送验证码 api
    async sendValidCode(validDate, firstValidRes) {
      const res = await user_sms_register({
        ...validDate,
        geeuser: firstValidRes.geeuser,
        phone: this.registerForm.phone,
      });
      if (res.code === 200) {
        this.countDownTimer = setInterval(() => {
          this.countDown--;
          if (this.countDown < 1) {
            this.countDown = 60;
            clearInterval(this.countDownTimer);
          }
        }, 1000);
      }
    },

    // 手机号失去焦点
    onPhoneBlur() {
      if (!this.registerForm.phone || !isvalidPhone(this.registerForm.phone)) return;

      this.checkPhone();
    },
    // 切换密码可见 click
    onVisiablePassword() {
      this.passwordInputType =
        this.passwordInputType === "password" ? "text" : "password";
    },
    // 注册 click
    onRegisterClick(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const res = await user_register(this.registerForm);
          if (res.code === 200) {
            this.$notify({
              type: "success",
              message: "注册成功。",
            });
            setTimeout(() => {
              this.$router.push("/login");
            }, 500);
          }
        }
      });
    },

    // 同意用户须知
    onConfirm(){
      this.registerReadModal = false
    },
    // 不同意用户须知
    onCancal(n) {
      this.$router.go(-1)
    },


    // 校验手机号 api
    async checkPhone() {
      try {
        let res = await user_checkPhone({
          phone: this.registerForm.phone,
        },{
          noPrint: true
        });
        if(res.code === 200){
          this.isAlreadyPhone = false
        }
      } catch (err) {
        this.isAlreadyPhone = true
      }
      this.$refs.registerForm.validateField('phone')

    },
    // 同意阅读条款 click
    onSignupReadClick(modal) {
      this.$set(this.registerForm, "agree", true);
      this[modal] = false;
    },
    // 触发表单校验时
    onValidateForm(prop, isValid, err) {
      if (prop === "phone") {
        this.passPhone = isValid;
      }
      if (prop === "password") {
        this.isValidPassword = isValid;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.register_w {
  .top_w {
    box-shadow: 0 2px 5px 0 rgba(#000,.1);
  }
  .span_1 {
    margin: 0 0 0 21px;
  }
  .span_2 {
    display: inline-block;
    height: 52px;
    margin: 0 0 0 20px;
    border-right: 1px dashed #e6e6e6;
  }
  .span_3 {
    margin: 0 0 0 10px;
  }
  .div_1 {
    margin: 0 21px 0 0;
  }
  .div_2 {
    width: 400px;
    height: 54px;
    line-height: 54px;
    margin: 30px 0 0 0;
  }
  .div_3 {
    margin: 0 0 30px 0;
  }

  ::v-deep .el-form-item__label {
    font-size: 16px;
    line-height: 60px;
    color: #1a1a1a;
  }
  ::v-deep .el-input__inner {
    height: 60px;
    line-height: 60px;
    ::-webkit-input-placeholder {
        /* Chrome/Safari/Opera */
        font-size: 16px;
      }
      ::-moz-placeholder {
        /* Firefox 19+ */
        font-size: 16px;
      }
      // :-ms-input-placeholder {
      //   /* IE 10+ 注意这里只有一个冒号 */
      //   font-size: 16px;
      // }
  }
  ::v-deep .el-input__prefix {
    left: 10px;
    top: 17px;
  }
}

.content_w {
  width: 910px;
  height: 686px;
  margin: 0 auto;
}
.register_c_w {
  margin: 0 auto;
  height: 100%;

  .initial_input {
    display: flex;
    align-items: center;
    width: 475px;
    .el-input {
      width: 449px;
    }
  }

  .warp_1 {
    display: flex;
    align-items: center;
    width: 475px;

    .el-input {
      width: 271px;
    }
    .send_vcode_btn {
      width: 168px;
      padding: 16px 0;
      margin: 0 0 0 10px;
      font-size: 16px;
      color: #fff;
      text-align: center;
      background: #0983cc;
      cursor: pointer;
    }
    .send_vcode_btn.is_active {
      &:active {
        background-color: rgba($color: #0983cc, $alpha: 0.9);
      }
    }
  }
}
</style>
